var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_756_41702)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_756_41702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.844 4.55202C37.3572 10.6214 35.7626 7.85945 35.7626 20C35.7626 32.1406 37.3572 29.3786 26.844 35.448C16.3308 41.5173 19.52 41.5173 9.00497 35.448C-1.50823 29.3786 0.0863841 32.1406 0.0863841 20C0.0863841 7.85945 -1.50823 10.6214 9.00497 4.55202C19.5182 -1.51734 16.3289 -1.51734 26.844 4.55202Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_756_41702)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3571 -1.51709H-1.5083V41.5194H37.3571V-1.51709Z",
    fill: "url(#paint0_linear_756_41702)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8293 6.32324L17.9399 7.82331L26.9349 13.3836L24.8293 6.32324Z",
    fill: "#D1D3D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2311 0.0517578L22.9963 0.171763L23.8127 2.91007L27.2311 0.0517578Z",
    fill: "#414042"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83765 -2.18994L11.4104 0.502908L11.5632 0.499272L12.8505 -2.18994H9.83765Z",
    fill: "#D1D3D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3732 4.46105L30.424 2.34277L24.4292 4.97562L24.8292 6.32295L33.3732 4.46105Z",
    fill: "#939598"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4684 -2.18994L3.08838 6.53045L11.4106 0.502908L3.71568 -2.18994H3.4684Z",
    fill: "#6D6E71"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81741 34.8501L0.530029 38.4903L5.81027 36.7465L2.81741 34.8501Z",
    fill: "#58595B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.7229 -2.18994L-0.797359 1.04293L0.520883 -2.18994H-2.7229Z",
    fill: "#E6E7E8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33 23.8511L2.32818 23.9165L2.30637 23.8874L1.10449 33.7643L2.8173 34.8498L9.23577 24.6402L2.33 23.8511Z",
    fill: "#414042"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4305 27.9749L11.4105 27.924L9.79768 23.5547L9.23584 24.6402L13.7051 34.137L11.4305 27.9749Z",
    fill: "#58595B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5954 7.74157L33.3733 4.46143L37.4044 15.6928L39.5954 7.74157Z",
    fill: "#231F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2298 -0.20459L30.4241 2.3428L33.3733 4.46108L36.2298 -0.20459Z",
    fill: "#414042"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4304 27.9751L13.7051 34.1372L19.4108 31.1316L11.4304 27.9751Z",
    fill: "#6D6E71"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4104 27.9242L11.4304 27.9751L11.4613 27.9023L11.4104 27.9242Z",
    fill: "#BCBEC0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6414 16.6054L13.456 16.4854L9.79761 23.5548L11.4104 27.9241L13.6414 16.6054Z",
    fill: "#A7A9AC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1113 25.106L30.3132 25.3878L30.4859 25.2969L30.4604 25.2132L30.1113 25.106Z",
    fill: "#414042"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81027 36.7466L0.530029 38.4903L8.76313 40.1376L9.58499 39.1394L5.81027 36.7466Z",
    fill: "#A7A9AC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51587 -2.18994L11.4105 0.502908L9.8377 -2.18994H9.51587Z",
    fill: "#BCBEC0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71558 -2.18994L11.4105 0.502908L9.51584 -2.18994H3.71558Z",
    fill: "#E6E7E8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76318 40.1374L12.267 40.8374L9.58504 39.1392L8.76318 40.1374Z",
    fill: "#D1D3D4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9349 13.3836L28.8223 14.551L33.3734 4.46143L24.8293 6.32333L26.9349 13.3836Z",
    fill: "#939598"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8506 -2.18994L11.5632 0.499272L20.4455 0.244715L21.2509 -2.18994H12.8506Z",
    fill: "#E6E7E8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8129 2.91018L22.9965 0.171875L20.4455 0.244606L17.9399 7.82313L23.8129 2.91018Z",
    fill: "#58595B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4293 4.97607L17.9399 7.82348L24.8293 6.32341L24.4293 4.97607Z",
    fill: "#F1F2F2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8222 14.5506L26.9348 13.3833L27.2585 14.4724L28.8058 14.5724L28.8222 14.5506Z",
    fill: "#58595B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6415 16.6055L15.7034 17.9419L17.4526 13.8362L17.9399 8.07962L18.1108 8.31963L17.9399 7.82324L13.5888 16.2309L13.4561 16.4855L13.6415 16.6055Z",
    fill: "#D1D3D4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9608 17.2984L37.4045 15.6928L33.3734 4.46143L28.8223 14.551L36.9608 17.2984Z",
    fill: "#939598"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9059 14.5799L30.6133 25.224L36.3681 19.4492L36.9608 17.2982L28.8223 14.5508L28.8059 14.5726L28.9059 14.5799Z",
    fill: "#A7A9AC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4859 25.2965L30.5768 25.2493L30.4604 25.2129L30.4859 25.2965Z",
    fill: "#6D6E71"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4613 27.9023L15.7033 17.9419L13.6414 16.6055L11.4104 27.9242L11.4613 27.9023Z",
    fill: "#F1F2F2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4291 4.97562L30.424 2.34277L27.2311 0.0517578L23.8127 2.91007L24.4291 4.97562Z",
    fill: "#A7A9AC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2298 -0.20459L27.2312 0.0517854L30.4241 2.3428L36.2298 -0.20459Z",
    fill: "#414042"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8129 2.91016L17.9399 7.82311L24.4293 4.9757L23.8129 2.91016Z",
    fill: "#808285"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2901 23.8638L-2.31738 27.0112L-0.968231 32.4514L1.10459 33.7642L2.30647 23.8874L2.2901 23.8638Z",
    fill: "#939598"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2927 -2.18994L22.9964 0.171984L27.2311 0.0519786L24.1092 -2.18994H22.2927Z",
    fill: "#E6E7E8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75561 11.4982V11.5L12.6377 9.42355L11.4304 0.779524L11.5631 0.499512L11.4104 0.503148L5.58105 11.3873L5.75561 11.4982Z",
    fill: "#808285"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33008 23.8513L9.23585 24.6404L9.79769 23.5549L5.57932 12.1289L2.33372 23.764L2.33008 23.8513Z",
    fill: "#58595B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5887 16.2309L12.6377 9.42334L5.75562 11.4998L13.456 16.4855L13.5887 16.2309Z",
    fill: "#A7A9AC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9844 31.8952L41.4847 36.9081L45.6849 32.1406L40.6937 29.1914L34.9844 31.8952Z",
    fill: "#808285"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1046 33.7646L0.530029 38.4903L2.81741 34.8502L1.1046 33.7646Z",
    fill: "#E6E7E8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23388 11.1906L5.21934 11.1524L3.04469 7.49951L2.94287 9.84144L5.23388 11.1906Z",
    fill: "#BCBEC0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04468 7.49961L5.21932 11.1525L5.58116 11.3871L11.4105 0.50293L3.08831 6.53048L3.04468 7.49961Z",
    fill: "#E6E7E8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82291 41.9595L6.9085 41.1849L0.530029 38.4902V41.9595H3.82291Z",
    fill: "#231F20"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75558 11.4981L5.58103 11.3872L5.57739 11.3945L5.75558 11.4981Z",
    fill: "#939598"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1091 -2.18994L27.2311 0.0519786L28.4457 -2.18994H24.1091Z",
    fill: "#58595B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3733 4.46122L39.5954 7.74137L40.8373 3.23571L39.1099 -0.288086L36.2298 -0.204446L33.3733 4.46122Z",
    fill: "#414042"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6551 25.866L30.486 25.2969L30.3132 25.3878L30.6551 25.866Z",
    fill: "#E6E7E8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M32.615 33.0626L32.775 32.9826L32.7041 32.7407L32.615 33.0626Z",
    fill: "#939598"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7785 34.837L19.4108 31.1313L13.7051 34.1369L28.8221 34.9297L28.7785 34.837Z",
    fill: "#6D6E71"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79772 23.5551L13.4561 16.4857L5.75572 11.5L5.57935 12.1291L9.79772 23.5551Z",
    fill: "#F1F2F2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9058 34.8883L28.7786 34.8373L28.8222 34.9301L32.6151 33.0627L32.7042 32.7409L32.1733 30.959L28.9058 34.8883Z",
    fill: "#231F20"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24833 11.1996L5.21924 11.1523L5.23378 11.1905L5.24833 11.1996Z",
    fill: "#808285"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57744 11.3942L5.58107 11.3869L5.21924 11.1523L5.24833 11.1996L5.57744 11.3942Z",
    fill: "#F1F2F2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9789 31.8987L34.9734 31.9077L34.9698 31.9023L32.7751 32.9823L33.577 35.6716L41.4846 36.908L34.9843 31.895L34.9789 31.8987Z",
    fill: "#231F20"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58502 39.1393L13.7052 34.1372L5.8103 36.7464L9.58502 39.1393Z",
    fill: "#D1D3D4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76313 40.1376L0.530029 38.4902L6.9085 41.1849L8.04673 40.8994L7.12488 41.2758L8.13583 41.7031L8.0431 41.0103L8.76313 40.1376Z",
    fill: "#939598"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1623 41.9591L31.5624 36.8807L28.8223 34.9297V41.9591H30.1623Z",
    fill: "#BCBEC0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M34.766 41.9593L34.5787 39.03L31.5622 36.8809L30.1621 41.9593H34.766Z",
    fill: "#E6E7E8"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5788 39.0302L41.4845 36.9083L33.5769 35.6719L34.5788 39.0302Z",
    fill: "#A7A9AC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8221 41.9594V34.93L13.7051 34.1372L27.6021 41.9594H28.8221Z",
    fill: "#BCBEC0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7051 34.1372L9.58496 39.1393L12.2669 40.8375L16.358 41.6557L13.7051 34.1372Z",
    fill: "#58595B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7125 41.9594H27.6021L13.7051 34.1372L16.3579 41.6557L16.7125 41.9594Z",
    fill: "#58595B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0462 41.9593L41.4846 36.9082L34.5789 39.0301L34.7661 41.9593H37.0462Z",
    fill: "#BCBEC0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2508 -2.18994L20.4453 0.244715L22.9963 0.171984L22.2927 -2.18994H21.2508Z",
    fill: "#808285"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6377 9.42323L17.9398 7.82315L20.4454 0.244629L11.5632 0.499186L11.4304 0.779199L12.6377 9.42323Z",
    fill: "#6D6E71"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2952 30.595L34.9443 31.8641L33.5006 29.8477L33.2952 30.595Z",
    fill: "#414042"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1533 23.8548L39.2135 22.5784L38.1207 17.6909L36.3679 19.4492L35.1533 23.8548Z",
    fill: "#414042"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9398 7.82324L12.6377 9.42331L13.5886 16.2309L17.9398 7.82324Z",
    fill: "#6D6E71"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0517 27.2368L34.9807 31.8934L34.9844 31.8952L40.6937 29.1914L40.4919 28.2914L37.0517 27.2368Z",
    fill: "#E6E7E8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6298 26.7987L34.4424 26.4351L33.7024 29.117L35.6298 26.7987Z",
    fill: "#A7A9AC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1733 30.9586L32.7043 32.7405L33.2952 30.5949L32.7952 30.2095L32.1733 30.9586Z",
    fill: "#808285"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6185 25.2622L30.6494 25.2713L35.1532 23.8549L36.3678 19.4492L30.613 25.224L30.6185 25.2622Z",
    fill: "#939598"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M31.966 35.4208L32.6152 33.0625L28.8223 34.9299L31.966 35.4208Z",
    fill: "#6D6E71"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3134 29.584L32.7952 30.2095L33.2952 30.5949L33.5007 29.8476L33.3134 29.584Z",
    fill: "#808285"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9788 31.899L34.9842 31.8954L34.9806 31.8936L34.9788 31.899Z",
    fill: "#A7A9AC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6222 25.2804L30.6186 25.2622L30.5768 25.2495L30.4858 25.2968L30.6549 25.8659L33.3132 29.5843L33.7024 29.117L34.4424 26.435L30.6495 25.2713L30.6222 25.2804Z",
    fill: "#808285"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M33.295 30.5952L32.7041 32.7408L32.775 32.9826L34.9697 31.9025L34.9442 31.8644L33.295 30.5952Z",
    fill: "#808285"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9658 35.4207L33.5768 35.6716L32.7749 32.9824L32.6149 33.0624L31.9658 35.4207Z",
    fill: "#58595B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5623 36.881L34.5788 39.0302L33.5769 35.6718L31.9659 35.4209L31.5623 36.881Z",
    fill: "#231F20"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5624 36.8807L31.966 35.4206L28.8223 34.9297L31.5624 36.8807Z",
    fill: "#D1D3D4"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4458 -2.18994L27.2312 0.0519786L36.2298 -0.204397L35.9171 -2.18994H28.4458Z",
    fill: "#414042"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.79932 29.3896L-4.80109 38.4901H0.530062L-0.968189 32.4516L-5.79932 29.3896Z",
    fill: "#414042"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.968262 32.4517L0.529989 38.4901L1.10456 33.7644L-0.968262 32.4517Z",
    fill: "#E6E7E8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57934 12.1288L5.38297 11.5942L2.85195 11.9052L2.33374 23.7639L5.57934 12.1288Z",
    fill: "#A7A9AC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29001 23.864L-5.76309 13.0126L-5.77218 12.9653L-5.80127 12.969L-2.31748 27.0114L2.29001 23.864Z",
    fill: "#BCBEC0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23373 11.1905L2.94272 9.84131L2.85181 11.905L5.38283 11.5941L5.23373 11.1905Z",
    fill: "#939598"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M0.529881 41.9595V38.4902H-4.80127L-4.41943 41.9595H0.529881Z",
    fill: "#E6E7E8"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47559 11.5836L5.7556 11.5V11.4982L5.57741 11.3945L5.47559 11.5836Z",
    fill: "#F1F2F2"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5774 11.3943L5.24829 11.1997L5.47557 11.5834L5.5774 11.3943Z",
    fill: "#D1D3D4"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38281 11.5945L5.57919 12.1291L5.75556 11.5L5.47554 11.5836L5.38281 11.5945Z",
    fill: "#808285"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47572 11.5832L5.24843 11.1995L5.23389 11.1904L5.38299 11.5941L5.47572 11.5832Z",
    fill: "#6D6E71"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3064 23.8878L2.32821 23.9169L2.33003 23.8514L2.31003 23.8496L2.3064 23.8878Z",
    fill: "#D1D3D4"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0.520879 -2.18994L-0.797363 1.04293L2.65552 6.84501L3.08827 6.53045L3.46829 -2.18994H0.520879Z",
    fill: "#A7A9AC"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.58141 3.66143L-7.43231 3.72507L0.502598 8.40347L2.65542 6.84521L-0.797463 1.04313L-0.837465 1.14132L-11.9889 -0.876953L-12.1089 -0.811496L-7.60868 3.51597L-7.58141 3.66143Z",
    fill: "#414042"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0.502718 8.40349L-7.43219 3.7251L-7.54492 3.84874L-5.77393 12.9492L0.502718 8.40349Z",
    fill: "#D1D3D4"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29004 23.8642L2.30641 23.8878L2.31004 23.8496L2.29004 23.8642Z",
    fill: "#939598"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04462 7.49979L2.65551 6.84521L0.502686 8.40347L2.9428 9.84171L3.04462 7.49979Z",
    fill: "#6D6E71"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31006 23.8496L2.33006 23.8514L2.3337 23.7642L2.31006 23.8496Z",
    fill: "#58595B"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08826 6.53027L2.65552 6.84483L3.04463 7.49941L3.08826 6.53027Z",
    fill: "#58595B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28997 23.864L2.30997 23.8495L2.33361 23.764L2.85181 11.9053L-5.77222 12.9653L-5.76312 13.0126L2.28997 23.864Z",
    fill: "#414042"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.77211 12.9653L2.85192 11.9053L2.94283 9.84157L0.502724 8.40332L-5.77393 12.949L-5.77211 12.9653Z",
    fill: "#231F20"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4603 25.2131L27.7402 16.0908L25.7219 18.9655L30.1112 25.1058L30.4603 25.2131Z",
    fill: "#D1D3D4"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8059 14.5727L27.2585 14.4727L27.7404 16.0909L28.8059 14.5727Z",
    fill: "#58595B"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5767 25.2496L30.6022 25.2351L30.6131 25.2241L28.9057 14.58L28.8057 14.5728L27.7402 16.091L30.4604 25.2132L30.5767 25.2496Z",
    fill: "#E6E7E8"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4424 26.4352L35.6297 26.7988L39.1099 22.6113L37.0516 27.237L40.4918 28.2916L39.2135 22.5786L35.1533 23.855L34.4424 26.4352Z",
    fill: "#A7A9AC"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5767 25.2496L30.6185 25.2623L30.613 25.2241L30.6021 25.235L30.5767 25.2496Z",
    fill: "#58595B"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4423 26.4351L35.1533 23.855L30.6494 25.2714L34.4423 26.4351Z",
    fill: "#A7A9AC"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6496 25.2713L30.6187 25.2622L30.6223 25.2804L30.6496 25.2713Z",
    fill: "#E6E7E8"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1114 25.1056L23.5747 23.1001L28.0731 26.5675L30.3132 25.3875L30.1114 25.1056Z",
    fill: "#D1D3D4"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2091 22.9877L22.9055 22.895L22.8618 22.8223L11.4613 27.9025L11.4304 27.9752L19.4108 31.1317L25.5238 27.9116L23.2091 22.9877Z",
    fill: "#BCBEC0"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2092 22.9878L25.5239 27.9117L28.0731 26.568L23.5747 23.1005L23.2092 22.9878Z",
    fill: "#414042"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4525 13.8364L15.7034 17.9421L22.62 22.4223L17.4525 13.8364Z",
    fill: "#BCBEC0"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1109 8.3196L17.9399 8.07959L17.4526 13.8362L20.0746 14.0071L18.1109 8.3196Z",
    fill: "#BCBEC0"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8619 22.8221L22.6201 22.4221L15.7034 17.9419L11.4614 27.9023L22.8619 22.8221Z",
    fill: "#E6E7E8"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0731 26.5679L25.5239 27.9116L28.7786 34.8373L28.9059 34.8882L32.1733 30.959L31.6969 29.3625L28.0731 26.5679Z",
    fill: "#939598"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4109 31.1318L28.7786 34.8374L25.5239 27.9116L19.4109 31.1318Z",
    fill: "#BCBEC0"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M28.073 26.5677L31.6968 29.3624L30.6549 25.8659L30.3131 25.3877L28.073 26.5677Z",
    fill: "#D1D3D4"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9734 31.908L34.9788 31.8989L34.9697 31.9026L34.9734 31.908Z",
    fill: "#808285"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7023 29.1171L33.5005 29.8481L34.9442 31.8645L34.9806 31.8936L37.0516 27.237L35.6297 26.7988L33.7023 29.1171Z",
    fill: "#808285"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5005 29.8476L33.7023 29.1167L33.3132 29.584L33.5005 29.8476Z",
    fill: "#BCBEC0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6969 29.3622L32.7951 30.2096L33.3133 29.5841L30.655 25.8657L31.6969 29.3622Z",
    fill: "#A7A9AC"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1732 30.9587L32.795 30.2096L31.6968 29.3623L32.1732 30.9587Z",
    fill: "#A7A9AC"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9443 31.8643L34.9698 31.9024L34.9789 31.8988L34.9807 31.8934L34.9443 31.8643Z",
    fill: "#D1D3D4"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2236 14.0161L23.0838 22.3001L25.573 18.7563L22.2801 14.1507L20.2236 14.0161Z",
    fill: "#6D6E71"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1109 8.31963L21.9619 13.7071L22.2801 14.1508L22.5965 14.1708L27.2585 14.4726L26.9349 13.3835L17.9399 7.82324L18.1109 8.31963Z",
    fill: "#A7A9AC"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5729 18.7565L25.722 18.9656L27.7403 16.091L27.2584 14.4727L22.5964 14.1709L22.28 14.1509L25.5729 18.7565Z",
    fill: "#BCBEC0"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0746 14.0074L20.2237 14.0164L22.2801 14.151L21.9619 13.7073L18.1108 8.31982L20.0746 14.0074Z",
    fill: "#58595B"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5747 23.1004L23.0837 22.7222L23.2092 22.9876L23.5747 23.1004Z",
    fill: "#F1F2F2"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2091 22.9876L23.0836 22.7222L22.8618 22.8222L22.9055 22.8949L23.2091 22.9876Z",
    fill: "#A7A9AC"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0838 22.7223L20.0746 14.0073L17.4526 13.8364L22.6201 22.4223L23.0838 22.7223Z",
    fill: "#E6E7E8"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6201 22.4219L22.8619 22.8219L23.0838 22.7219L22.6201 22.4219Z",
    fill: "#A7A9AC"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6296 26.7988L37.0515 27.237L39.1098 22.6113L35.6296 26.7988Z",
    fill: "#D1D3D4"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0837 22.722L25.722 18.9654L25.5729 18.7563L22.9873 22.4383L23.0837 22.722Z",
    fill: "#A7A9AC"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5747 23.1001L30.1113 25.1056L25.722 18.9653L23.0837 22.7219L23.5747 23.1001Z",
    fill: "#939598"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9873 22.4386L23.1091 22.2659L20.2217 14.0073H20.0745",
    fill: "#808285"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.186523 8.5051L1.31536 15.3963L6.87562 6.40137L-0.186523 8.5051Z",
    fill: "#6D6E71"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.0049 21.9238L-8.7832 29.8642L0.0226526 30.2478L-6.0049 21.9238Z",
    fill: "#D1D3D4"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M28.342 30.5169L31.9822 32.8061L30.2367 27.5259L28.342 30.5169Z",
    fill: "#808285"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3435 31.0045L17.409 31.0082L17.3781 31.03L27.2567 32.2319L28.3422 30.5172L18.1326 24.1006L17.3435 31.0045Z",
    fill: "#BCBEC0"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4672 21.9055L21.4145 21.9237L17.0452 23.5383L18.1325 24.1002L27.6293 19.6309L21.4672 21.9055Z",
    fill: "#414042"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4673 21.9057L27.6294 19.631L24.6238 13.9253L21.4673 21.9057Z",
    fill: "#A7A9AC"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4146 21.9241L21.4674 21.9059L21.3928 21.875L21.4146 21.9241Z",
    fill: "#BCBEC0"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0978 19.6948L9.97778 19.8803L17.0454 23.5386L21.4147 21.924L10.0978 19.6948Z",
    fill: "#E6E7E8"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5981 3.22466L18.8782 3.02283L18.7872 2.8501L18.7036 2.87555L18.5981 3.22466Z",
    fill: "#808285"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2368 27.5262L31.9824 32.8064L33.6279 24.5733L32.6297 23.7515L30.2368 27.5262Z",
    fill: "#58595B"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6279 24.573L34.3297 21.0674L32.6296 23.7511L33.6279 24.573Z",
    fill: "#414042"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1605 17.0253H35.1696L35.1478 16.978L34.3296 21.0673L35.8951 18.5963L35.1769 17.0398L35.1605 17.0253Z",
    fill: "#BCBEC0"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8757 6.40137L8.04303 4.51401L-2.04834 -0.0371094L-0.186437 8.5051L6.8757 6.40137Z",
    fill: "#A7A9AC"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.59739 9.52344L-6.33569 10.338L-6.26296 12.8909L1.31556 15.3964L-3.59739 9.52344Z",
    fill: "#808285"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.53198 8.90672L1.31542 15.3961L-0.186466 8.50488L-1.53198 8.90672Z",
    fill: "#6D6E71"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04306 4.51416L6.87573 6.40152L7.96487 6.07605L8.06488 4.52871L8.04306 4.51416Z",
    fill: "#939598"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0976 19.6947L11.4341 17.631L7.32843 15.8837L1.57181 15.3964L1.81182 15.2236L1.31543 15.3964L9.72127 19.7475L9.97764 19.8802L10.0976 19.6947Z",
    fill: "#58595B"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95193 -2.18994L-2.04834 -0.0371165L8.04303 4.514L10.3068 -2.18994H3.95193Z",
    fill: "#6D6E71"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06479 4.52836L8.07024 4.43018L8.04297 4.51382L8.06479 4.52836Z",
    fill: "#808285"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7851 -2.18994H10.3068L8.07031 4.42854L18.7163 2.72301L13.7851 -2.18994Z",
    fill: "#58595B"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7873 2.85019L18.74 2.75928L18.7036 2.87565L18.7873 2.85019Z",
    fill: "#A7A9AC"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3927 21.8747L11.4341 17.6309L10.0977 19.6946L21.4145 21.9238L21.3927 21.8747Z",
    fill: "#231F20"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.59741 9.52313L1.31554 15.3961L-1.53186 8.90674L-3.59741 9.52313Z",
    fill: "#414042"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M22.88 39.1358H22.8818L25.9438 34.3047L20.5017 35.6538L22.88 39.1358Z",
    fill: "#808285"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60279 41.9596L6.45928 39.1376L6.4411 39.1104L-2.66113 40.8795L-1.46653 41.9596H3.60279Z",
    fill: "#BCBEC0"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36664 41.9592L6.45928 39.1372L3.60278 41.9592H8.36664Z",
    fill: "#939598"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3562 31.0461L20.5018 35.6536L25.9439 34.3045L27.2567 32.2317L17.378 31.0298L17.3562 31.0461Z",
    fill: "#BCBEC0"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99025 27.5804L2.91561 20.6982L-5.73024 21.9056L-6.01025 21.771L-6.0048 21.9238L4.87751 27.7549L4.99025 27.5804Z",
    fill: "#E6E7E8"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72129 19.7476L2.91553 20.6985L4.99017 27.5806L9.97767 19.8803L9.72129 19.7476Z",
    fill: "#D1D3D4"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3421 30.5168L30.2368 27.5258L27.6294 19.6309L18.1326 24.1002L28.3421 30.5168Z",
    fill: "#939598"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2566 32.2317L31.9823 32.8063L28.3421 30.5171L27.2566 32.2317Z",
    fill: "#939598"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68288 28.1025L4.64288 28.1171L0.98999 30.2899L3.33192 30.3936L4.68288 28.1025Z",
    fill: "#58595B"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1951 25.2006L34.7678 26.2115L37.4661 32.8064H42.39H42.4682L38.7335 24.7314L35.1951 25.2006Z",
    fill: "#6D6E71"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M0.989981 30.2897L4.64287 28.1168L4.87743 27.755L-6.00488 21.9238L0.0226655 30.2478L0.989981 30.2897Z",
    fill: "#6D6E71"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6771 26.4277L31.9824 32.8062H36.2772L34.6771 26.4277Z",
    fill: "#231F20"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99017 27.5806L4.87744 27.7551L4.88471 27.7588L4.99017 27.5806Z",
    fill: "#A7A9AC"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3562 2.68115L18.7871 2.85025L18.878 3.02299L19.3562 2.68115Z",
    fill: "#BCBEC0"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5529 0.720908L26.4747 0.559082L26.2329 0.631813L26.5529 0.720908Z",
    fill: "#414042"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3276 4.5578L24.6238 13.9255L27.6294 19.6312L28.4203 4.51416L28.3276 4.5578Z",
    fill: "#BCBEC0"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0453 23.5387L9.97774 19.8804L4.99023 27.5807L5.61936 27.7571L17.0453 23.5387Z",
    fill: "#D1D3D4"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3785 4.42837L28.3276 4.55747L28.4203 4.51383L26.553 0.720931L26.2329 0.631836L24.4492 1.16277L28.3785 4.42837Z",
    fill: "#F1F2F2"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69192 28.0879L4.64282 28.117L4.68282 28.1024L4.69192 28.0879Z",
    fill: "#414042"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88465 27.7585L4.87738 27.7549L4.64282 28.1167L4.69192 28.0876L4.88465 27.7585Z",
    fill: "#BCBEC0"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8056 -2.18994L25.3875 -1.6481L25.3893 -1.64264L25.4002 -1.63901L25.3947 -1.63355L26.4748 0.559274L29.164 -0.24258L29.4676 -2.18994H25.8056Z",
    fill: "#F1F2F2"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6296 23.751L27.6294 19.6309L30.2368 27.5258L32.6296 23.751Z",
    fill: "#58595B"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M33.628 24.5732L31.9824 32.8063L34.6771 26.4279L34.3916 25.2896L34.768 26.2115L35.1953 25.2005L34.5007 25.2915L33.628 24.5732Z",
    fill: "#58595B"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1371 4.51405L39.5573 4.30495L36.4862 3.45946L36.2153 4.42859L36.4335 3.44491L30.3732 1.77393L28.4204 4.51405H36.1371Z",
    fill: "#E6E7E8"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4333 3.44487L37.5443 -1.56445L32.5222 -1.24262L30.373 1.77388L36.4333 3.44487Z",
    fill: "#E6E7E8"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4203 4.51416L27.6294 19.6312L36.1371 4.51416H28.4203Z",
    fill: "#F1F2F2"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1951 25.2004L38.7334 24.7313L36.9879 20.9565L35.1951 25.2004Z",
    fill: "#939598"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1479 16.9784L35.1698 17.0257L36.8971 17.0166L40.9755 10.5781L40.7955 10.3545L35.1479 16.9784Z",
    fill: "#F1F2F2"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M35.177 17.04L35.8952 18.5965L36.257 18.0274L35.177 17.04Z",
    fill: "#D1D3D4"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8953 18.5967L34.3298 21.0677L33.6279 24.5733L34.5007 25.2915L35.1953 25.2006L36.9881 20.9568L35.8953 18.5967Z",
    fill: "#BCBEC0"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6294 19.6309L32.6296 23.7511L34.3297 21.0673L35.1479 16.978L27.6294 19.6309Z",
    fill: "#D1D3D4"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1371 4.51416L27.6294 19.6312L35.1479 16.9784L40.7954 10.3544L36.1371 4.51416Z",
    fill: "#231F20"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91541 20.6983L1.31534 15.3962L-6.26318 12.8906L-6.01044 21.771L-5.73043 21.9056L2.91541 20.6983Z",
    fill: "#F1F2F2"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0857 0.0412558L25.3567 -1.60791L23.3384 -0.166026L24.0857 0.0412558Z",
    fill: "#E6E7E8"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31543 15.3965L2.9155 20.6985L9.72127 19.7476L1.31543 15.3965Z",
    fill: "#E6E7E8"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4493 1.16288L26.233 0.631952L24.0857 0.0410156L23.7002 0.541038L24.4493 1.16288Z",
    fill: "#414042"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9962 -2.18994H13.7852L18.7163 2.72301L18.7527 2.71755L18.7617 2.68664L17.3471 -1.8172L15.9962 -2.18994Z",
    fill: "#939598"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9113 1.37031L26.553 0.721191L28.4203 4.51409L28.9113 1.37031Z",
    fill: "#D1D3D4"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0764 0.0230839L23.7001 0.541289L24.0856 0.0412666L23.3382 -0.166016L23.0764 0.0230839Z",
    fill: "#414042"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7709 2.71373L18.7527 2.71736L18.74 2.75918L18.7873 2.8501L19.3564 2.681L23.0765 0.0226969L22.6074 -0.36823L19.9255 -1.10645L18.7618 2.68645L18.7709 2.71373Z",
    fill: "#E6E7E8"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0857 0.0408325L26.2331 0.631768L26.4749 0.559037L25.3948 -1.63379L25.3567 -1.60833L24.0857 0.0408325Z",
    fill: "#F1F2F2"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9113 1.37012L29.1641 -0.242676L26.4749 0.559179L26.553 0.721004L28.9113 1.37012Z",
    fill: "#A7A9AC"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M30.373 1.77382L32.5222 -1.24268L29.1639 -0.24263L28.9111 1.37017L30.373 1.77382Z",
    fill: "#F1F2F2"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3732 1.77377L28.9113 1.37012L28.4204 4.5139L30.3732 1.77377Z",
    fill: "#808285"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8761 41.9595L22.8745 39.1412L22.8672 39.1376L22.88 39.1358L20.5017 35.6538L6.45923 39.1376L13.7814 41.9595H17.8761Z",
    fill: "#6D6E71"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9568 41.9592L22.8838 39.1445L24.4439 41.9592H29.9568Z",
    fill: "#D1D3D4"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8818 39.1355L31.9822 38.1373V32.8062L25.9438 34.3044L22.8818 39.1355Z",
    fill: "#808285"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44116 39.1101L6.45935 39.1374L6.45571 39.1064L6.44116 39.1101Z",
    fill: "#939598"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9438 34.3043L31.9823 32.806L27.2566 32.2314L25.9438 34.3043Z",
    fill: "#6D6E71"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3563 31.0459L6.5049 39.0972L6.45581 39.1063L6.45945 39.1372L20.5019 35.6534L17.3563 31.0459Z",
    fill: "#808285"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4438 41.9594L22.8837 39.1448L22.8746 39.1411L17.8762 41.9594H24.4438Z",
    fill: "#E6E7E8"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M4.683 28.1022L3.33203 30.3932L5.39758 30.4823L5.08666 27.9531L4.683 28.1022Z",
    fill: "#939598"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4627 37.5336L36.2772 32.8062H31.9824V38.1373L37.4627 37.5336Z",
    fill: "#E6E7E8"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7814 41.9592L6.45923 39.1372L8.36659 41.9592H13.7814Z",
    fill: "#414042"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07387 27.8606L4.99023 27.5806L4.88477 27.7588L5.07387 27.8606Z",
    fill: "#939598"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88463 27.7588L4.69189 28.0879L5.07373 27.8606L4.88463 27.7588Z",
    fill: "#A7A9AC"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0866 27.9533L5.61936 27.7569L4.99023 27.5806L5.07388 27.8606L5.0866 27.9533Z",
    fill: "#D1D3D4"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07379 27.8604L4.69195 28.0876L4.68286 28.1022L5.08652 27.9531L5.07379 27.8604Z",
    fill: "#E6E7E8"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3779 31.0299L17.4088 31.008L17.3434 31.0044L17.3416 31.0262L17.3779 31.0299Z",
    fill: "#D1D3D4"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.46482 34.1335L0.335447 30.6807L0.0227079 30.2479L-8.78315 29.8643L-9.67773 32.4171L-5.46482 34.1335Z",
    fill: "#F1F2F2"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.77588 41.9594H-3.96848L-2.99389 40.9448L-2.84661 40.9157L-2.78479 40.7684L1.89361 32.8335L0.335352 30.6807L-5.46491 34.1335L-5.36672 34.1736L-6.77588 41.9594Z",
    fill: "#808285"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89373 32.8335L-2.78467 40.7684L-2.66103 40.8793L6.44121 39.1101L1.89373 32.8335Z",
    fill: "#414042"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3561 31.0459L17.3779 31.0295L17.3416 31.0259L17.3561 31.0459Z",
    fill: "#414042"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M0.990026 30.2896L0.335449 30.6805L1.8937 32.8333L3.33195 30.3932L0.990026 30.2896Z",
    fill: "#414042"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3417 31.0259L17.3435 31.0041L17.2544 31.0005L17.3417 31.0259Z",
    fill: "#939598"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0227051 30.248L0.335444 30.6808L0.99002 30.2899L0.0227051 30.248Z",
    fill: "#808285"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3562 31.0461L17.3416 31.0261L17.2544 31.0006L5.39746 30.4824L6.45569 39.1064L6.50478 39.0974L17.3562 31.0461Z",
    fill: "#58595B"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8801 39.1376L22.8819 39.1357H22.8801V39.1376Z",
    fill: "#6D6E71"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5918 41.9593L40.7918 40.9375L40.6063 40.4811L37.5535 37.5337L32.9551 41.9593H40.5918Z",
    fill: "#F1F2F2"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2771 32.8063H37.4662L34.7679 26.2114L34.677 26.4278L36.2771 32.8063Z",
    fill: "#808285"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6771 26.4278L34.768 26.2114L34.3916 25.2896L34.6771 26.4278Z",
    fill: "#A7A9AC"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9568 41.9592H31.9824V38.1372L22.8819 39.1354L22.8801 39.1373L22.8838 39.1445L29.9568 41.9592Z",
    fill: "#58595B"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8674 39.1376L22.8747 39.1412L22.8802 39.1376V39.1357L22.8674 39.1376Z",
    fill: "#414042"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9824 41.9593H32.9552L38.8791 36.259L37.4663 32.8062H36.2772L37.4627 37.5336L31.9824 38.1373V41.9593Z",
    fill: "#BCBEC0"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8836 39.1445L22.88 39.1372L22.8745 39.1408L22.8836 39.1445Z",
    fill: "#939598"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1606 17.0254L35.177 17.0399L35.1697 17.0254H35.1606Z",
    fill: "#939598"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M35.177 17.0402L36.257 18.0276L36.897 17.0166L35.1697 17.0257L35.177 17.0402Z",
    fill: "#6D6E71"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7035 2.87598L9.5813 5.59428L12.456 7.61437L18.5981 3.22508L18.7035 2.87598Z",
    fill: "#939598"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06485 4.52832L7.96484 6.07566L9.58128 5.59382L8.06485 4.52832Z",
    fill: "#E6E7E8"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M18.74 2.75951L18.7254 2.73405L18.7163 2.72314L8.0704 4.42868L8.06494 4.52868L9.58137 5.59418L18.7036 2.87588L18.74 2.75951Z",
    fill: "#F1F2F2"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7399 2.75959L18.7527 2.71777L18.7163 2.72323L18.7254 2.73414L18.7399 2.75959Z",
    fill: "#414042"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9255 -1.10644L17.3472 -1.81738L18.7618 2.68646L19.9255 -1.10644Z",
    fill: "#808285"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7618 2.68652L18.7527 2.71743L18.7709 2.7138L18.7618 2.68652Z",
    fill: "#BCBEC0"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5979 3.22478L16.5906 9.76144L20.0598 5.26305L18.878 3.02295L18.5979 3.22478Z",
    fill: "#D1D3D4"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4798 10.1272L16.3852 10.4308L16.3125 10.4744L21.3927 21.875L21.4673 21.9059L24.6238 13.9255L21.4018 7.8125L16.4798 10.1272Z",
    fill: "#BCBEC0"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4797 10.127L21.4018 7.81239L20.0599 5.26318L16.5907 9.76157L16.4797 10.127Z",
    fill: "#939598"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32837 15.8838L11.434 17.6312L15.9124 10.7163L7.32837 15.8838Z",
    fill: "#808285"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81179 15.2235L1.57178 15.3962L7.3284 15.8835L7.49932 13.2598L1.81179 15.2235Z",
    fill: "#58595B"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 10.4741L15.9125 10.716L11.4341 17.6308L21.3927 21.8746L16.3125 10.4741Z",
    fill: "#D1D3D4"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0601 5.26327L21.4019 7.81248L28.3277 4.55779L28.3786 4.42869L24.4493 1.16309L22.8529 1.63947L20.0601 5.26327Z",
    fill: "#6D6E71"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6238 13.9253L28.3276 4.55762L21.4019 7.81231L24.6238 13.9253Z",
    fill: "#6D6E71"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M20.06 5.26296L22.8529 1.63916L19.3564 2.68103L18.8782 3.02286L20.06 5.26296Z",
    fill: "#939598"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3384 -0.166337L22.6074 -0.368164L23.0765 0.0227627L23.3384 -0.166337Z",
    fill: "#6D6E71"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8527 1.63939L23.7 0.541155L23.0764 0.0229492L19.3562 2.68125L22.8527 1.63939Z",
    fill: "#231F20"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4492 1.16286L23.7001 0.541016L22.8528 1.63925L24.4492 1.16286Z",
    fill: "#808285"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50854 13.1107L15.7907 10.2506L12.2469 7.76318L7.64128 11.0561L7.50854 13.1107Z",
    fill: "#6D6E71"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81182 15.2234L7.19752 11.3723L7.64117 11.0559L7.66117 10.7395L7.96482 6.07568L6.87568 6.40115L1.31543 15.3961L1.81182 15.2234Z",
    fill: "#939598"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2468 7.76343L12.4559 7.61433L9.5812 5.59424L7.96476 6.07608L7.66111 10.7399L7.64111 11.0563L12.2468 7.76343Z",
    fill: "#808285"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4993 13.2599L7.50839 13.1108L7.64112 11.0562L7.19747 11.3725L1.81177 15.2236L7.4993 13.2599Z",
    fill: "#A7A9AC"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5906 9.76172L16.2124 10.2508L16.4797 10.1272L16.5906 9.76172Z",
    fill: "#808285"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4797 10.127L16.2124 10.2506L16.3124 10.4742L16.3851 10.4306L16.4797 10.127Z",
    fill: "#D1D3D4"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2124 10.2505L7.49929 13.2597L7.32837 15.8835L15.9124 10.716L16.2124 10.2505Z",
    fill: "#58595B"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9126 10.716L16.3126 10.4741L16.2126 10.2505L15.9126 10.716Z",
    fill: "#231F20"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2125 10.2507L12.4559 7.61426L12.2468 7.76336L15.9306 10.3489L16.2125 10.2507Z",
    fill: "#58595B"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5908 9.76127L18.5982 3.22461L12.4561 7.6139L16.2126 10.2504L16.5908 9.76127Z",
    fill: "#A7A9AC"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9306 10.3489L15.756 10.2271L7.49927 13.1145V13.2599",
    fill: "#939598"
  }))))), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.084 9.33571C31.3425 13.5268 30.2424 11.6194 30.2424 20.0016C30.2424 28.3838 31.3443 26.4765 24.084 30.6676C16.8254 34.8587 19.0274 34.8587 11.767 30.6676C4.50852 26.4765 5.60857 28.3838 5.60857 20.0016C5.60857 11.6194 4.50671 13.5268 11.767 9.33571C19.0255 5.14461 16.8236 5.14461 24.084 9.33571Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7842 12.9378C30.5442 14.0379 30.2424 15.6034 30.2424 20C30.2424 28.3822 31.3442 26.4748 24.0839 30.6659C19.9819 33.0351 18.9 34.0642 17.4254 33.7551C16.6654 32.6551 16.9672 31.0896 16.9672 26.693C16.9672 18.3108 15.8653 20.2182 23.1257 16.0271C27.2295 13.6579 28.3095 12.6287 29.7842 12.9378Z",
    fill: "url(#paint1_linear_756_41702)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.06678 12.8835C5.30674 13.9835 5.60857 15.5491 5.60857 19.9456C5.60857 28.3278 4.50671 26.4205 11.767 30.6116C14.8835 32.4098 16.2563 33.4372 17.3818 33.6917C16.6763 32.5953 16.9673 31.0061 16.9673 26.6932C16.9673 21.4912 16.5436 20.2529 17.9582 19.0583C17.1073 18.3092 15.549 17.6019 12.7253 15.9709C8.62144 13.6017 7.54139 12.5726 6.06678 12.8817",
    fill: "#E2E3EC"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2948 12.2794L17.9362 17.5524L8.46851 12.2831L17.8271 7.01011L27.2948 12.2794ZM28.5094 12.2794L17.8198 6.33008L7.25391 12.2849L17.9435 18.2343L28.5094 12.2794ZM21.9564 9.98479C24.2292 11.2503 24.251 13.3104 22.0037 14.5759C19.7563 15.8414 16.0779 15.8432 13.8051 14.5777C11.5323 13.3122 11.5105 11.2521 13.7578 9.98661C16.0052 8.7211 19.6836 8.71928 21.9564 9.98479ZM22.5601 9.64477C19.9454 8.19016 15.7307 8.19016 13.1469 9.64659C10.5631 11.103 10.5868 13.4631 13.2015 14.9177C15.8161 16.3724 20.0309 16.3724 22.6146 14.9159C25.1984 13.4595 25.1747 11.0994 22.5601 9.64477ZM21.3927 14.2377C23.311 13.1577 23.2928 11.4067 21.3527 10.3266C19.4126 9.24657 16.2852 9.24839 14.3688 10.3266C12.4505 11.4067 12.4687 13.1577 14.4088 14.2377C16.3489 15.3178 19.4763 15.3159 21.3927 14.2377Z",
    fill: "#DDDEE9"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9618 8.35742H17.4672L15.0671 13.4358H19.0091L20.0783 15.6778H21.3747L17.9636 8.35742H17.9618ZM18.46 12.2649H16.9509L17.7109 10.6666L18.46 12.2649Z",
    fill: "#55217E"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3659 19.407C27.3659 19.9471 27.2168 20.4925 26.9222 21.0271C26.6295 21.558 26.224 22.0399 25.7185 22.4563C25.3658 22.7454 24.744 23.1508 23.8185 23.6927L23.5784 23.8327V27.1947L22.3057 27.9383V23.3327L24.5312 22.0326C25.0967 21.7017 25.3749 21.4762 25.5094 21.3453C25.684 21.1744 25.8186 20.9871 25.9186 20.7744C26.0222 20.5562 26.0713 20.3562 26.0713 20.1652C26.0713 19.9743 26.0222 19.8307 25.9186 19.7325C25.8186 19.6379 25.6913 19.607 25.5294 19.6361C25.4058 19.6598 25.1385 19.7561 24.5785 20.0852L22.3057 21.4144V20.1616L24.0185 19.1597C24.8767 18.6579 25.4458 18.3633 25.7567 18.2597C26.2295 18.1015 26.6186 18.1161 26.9168 18.3015C27.2168 18.4906 27.3695 18.8615 27.3695 19.4052L27.3659 19.407Z",
    fill: "#55217E"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8161 25.4114C14.8161 26.1132 14.6597 26.6569 14.3524 27.0278C14.0415 27.4005 13.6324 27.5824 13.1342 27.5642C12.6433 27.5478 11.956 27.2951 11.0941 26.8132L8.73218 25.495V22.1421L9.87223 22.7785V24.9968L10.3832 25.2823C11.2668 25.7768 11.8832 26.0678 12.2142 26.1459C12.6596 26.2496 12.9996 26.1878 13.256 25.9532C13.5124 25.7186 13.6415 25.3186 13.6415 24.7622C13.6415 24.1768 13.5015 23.5949 13.2233 23.0313C12.9469 22.4694 12.5669 21.9876 12.0669 21.5566C11.6741 21.2166 11.0105 20.7857 10.0904 20.2711L8.734 19.5129V18.3638L10.3577 19.2711C11.3887 19.8457 12.1232 20.3402 12.6051 20.7821C13.2942 21.4075 13.8433 22.1403 14.2342 22.9603C14.6215 23.7713 14.8179 24.595 14.8179 25.4095L14.8161 25.4114Z",
    fill: "#55217E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_756_41702",
    x1: 40.7118,
    y1: 62.0803,
    x2: 4.06105,
    y2: -5.60273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#69217E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#06624C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_756_41702",
    x1: 24.1476,
    y1: 15.6289,
    x2: 25.2385,
    y2: 30.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C2D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDFEA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_756_41702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ad8a35db.svg";
export { ForwardRef as ReactComponent };